__webpack_require__.p = "https://assets.canny.io/d7970505cec6240a9943d740f1206f61c835fc4f/";